import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLoader from '../../ui-library/PageLoader';
import { useAuth } from '../auth/AuthProvider';

/**
 * Legacy /signup route: redirects into the app so SignupModal (in AuthProvider) can overlay /chat.
 */
export const SignupContainer: React.FC = () => {
  const navigate = useNavigate();
  const { user, isInitializing } = useAuth();

  useEffect(() => {
    if (isInitializing) return;
    if (!user) {
      navigate('/');
      return;
    }
    navigate('/chat', { replace: true });
  }, [isInitializing, navigate, user]);

  return <PageLoader />;
};
